module.exports = __webpack_public_path__ + "static/tom-hirst-in-oslo-64a25c80a0428133d43223ccdf24f60d.jpg";